import React from "react";
import { HiArrowNarrowRight } from "react-icons/hi";
import { Link } from "react-scroll";
import { TypeAnimation } from "react-type-animation";
import HireMeBtn from "./smallComponentes/HireMeBtn";
function Home() {
  return (
    <section id="home" name="home" className="w-full h-screen bg-[#0f172a]">
      {/* Container */}
      <div className="max-w-[1000px] mx-auto px-8 flex flex-col justify-center h-full">
        <p className="text-violet-600">Hi, my name is</p>
        <h1 className="text-4xl sm:text-7xl font-bold text-[#ccd6f6]">
          Ahmaddin
        </h1>

        <TypeAnimation
          sequence={["I'm a Frontend Developer.", 100]}
          speed={50}
          wrapper="h2"
          className="text-4xl sm:text-7xl font-bold text-[#8892b0] pb-4 "
          repeat={0}
        />
        {/* <p className="text-[#8892b0] py-4  max-w-[700px]">
          I am dedicated to continuously learning and growing in the field of
          web development.
        </p> */}
        <div className="flex">
          <Link to="work" smooth={true} duration={500}>
            <button className="flex items-center px-6 py-3 mx-2 text-white border-2 group hover:bg-violet-600 hover:border-violet-600">
              View Work
              <span className="duration-300 group-hover:rotate-90">
                <HiArrowNarrowRight className="ml-3" />
              </span>
            </button>
          </Link>
          <HireMeBtn />
        </div>
      </div>
    </section>
  );
}

export default Home;
